import React from "react";

const AllChartsDB = () => {
  return (
    <div>
      <h1>All Charts DB</h1>
      <p>Content of the all charts mega database page...</p>
    </div>
  );
};

export default AllChartsDB;
